module.exports = __webpack_public_path__ + "static/img_0583-3ca1d091f705dceb59853ba8600ab061.webp";